import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { prettifyNumber } from '@nexio/emvio-util-app';

import Widget from '../Widget/Widget';

import './ResellerTransactionsWidget.scss';

export default class ResellerTransactionsWidget extends Component {
    static propTypes = {
        lastThirtySaleCount: PropTypes.number,
        lastThirtyVsPreviousThirtySaleCount: PropTypes.number
    };

    renderSide(data) {
        return (
            <Fragment>
                <div className="widget-heading">{data.title}</div>
                <div className="widget-value">{data.value}</div>
                <div className="widget-delta">
                    <span className="material-icons">
                        {data.deltaDirection === 'up' ? 'arrow_drop_up' : 'arrow_drop_down'}
                    </span>
                    {data.deltaText}
                </div>
            </Fragment>
        );
    }

    render() {
        const { lastThirtySaleCount } = this.props;

        const ticketCount = {
            title: 'Last 30 Days Transaction Count',
            value: lastThirtySaleCount ? prettifyNumber(lastThirtySaleCount) : '--',
            deltaText: `${prettifyNumber(Math.abs(this.props.lastThirtyVsPreviousThirtySaleCount), 0, 1)}% from previous 30 days`,
            deltaDirection: this.props.lastThirtyVsPreviousThirtySaleCount > 0 ? 'up' : 'down'
        };

        return (
            <div className="reseller-transactions-widget widget-layout">
                <div className="widget-title">
                    Transactions
                </div>
                <Widget
                    left={this.renderSide(ticketCount)}
                    varient="dark"
                />
            </div>
        );
    }
}
